// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var fetcher = require('fetchers/Izenda.SystemSettingFetcher.js');
  var SettingLevel = require('./models/Izenda.SettingLevel');
  var uiState = require('logic/Izenda.UiState.js');
  var m = require('mobx');

  var ContextMenuStore = require('./Izenda.ContextMenuStore');
  var LicenseCheckerStore = require('./Izenda.LicenseCheckerStore');
  var DataModelStore = require('./Izenda.DataModelStore');
  var AdvancedSettingsStore = require('./Izenda.AdvancedSettingsStore');
  var TenantManagementStore = require('./Izenda.TenantManagementStore');
  var SchedulingSearchStore = require('logic/Izenda.SchedulingSearchStore');
  var EmailConfigurationStore = require('logic/Izenda.EmailConfigurationStore');
  var ReportConfigurationStore = require('logic/Izenda.ReportConfigurationStore');
  var systemSettingFetcher = require('fetchers/Izenda.SystemSettingFetcher');  

  var disablePages = ['setupAndLicense', 'tenantManagement', 'copyManagement', 'securityPolicies', 'databaseMapping'];
  var onlyShowTenant = [];
  var { forEach, invoke } = require('lodash/fp');

  function SettingsStore() {
    this.settingLevel = new SettingLevel();

    this.contextMenu = new ContextMenuStore();
    this.licenseChecker = new LicenseCheckerStore();
    this.dataModel = new DataModelStore();
    this.advanceSettings = new AdvancedSettingsStore();
    this.tenantManagement = new TenantManagementStore();
    this.schedulingSearch = new SchedulingSearchStore();
    this.emailConfiguration = new EmailConfigurationStore();
    this.reportConfiguration = new ReportConfigurationStore();    
    
    var instances = [
      this.contextMenu,
      this.licenseChecker,
      this.dataModel,
      this.advanceSettings,
      this.tenantManagement,
      this.schedulingSearch,
      this.emailConfiguration,
      this.reportConfiguration
    ];

    forEach(invoke('init'), instances);
  }

  /**
   * Load Setting Level
   */
  SettingsStore.prototype.loadSettingLevel = m.action(function() {
    fetcher.getSystemMode().then(
      function(systemMode) {
        this.settingLevel.loadInitial(systemMode);
        !systemMode && this.loadTenants();
      }.bind(this)
    );
  });

  /**
   * Load tenants
   */
  SettingsStore.prototype.loadTenants = function(shouldLoadDefaultTenant) {
    return fetcher.getTenants().then(this.settingLevel.readTenants.bind(this.settingLevel, shouldLoadDefaultTenant));
  };

  /**
   * Change system mode
   */
  SettingsStore.prototype.changeSystemMode = m.action(function(change) {
    return change.value === 'Tenant' ? this.loadTenants(true) : this.settingLevel.setSelectedTenant(null);
  });

  SettingsStore.prototype.onlyShowTenant = m.action(function(change) {
    uiState.onlyShowTenant = change;
    if (change) {
      uiState.enableSystemSetting(change);
      !uiState.tenantId && this.loadTenants(true);
    }
  });

  SettingsStore.prototype.checkSettingLevel = m.action(function(newLink) {
    newLink = newLink || this.contextMenu.contextMenuActiveLink;
    uiState.setDisableSettingLevel(disablePages.indexOf(newLink) > -1);
    this.onlyShowTenant(onlyShowTenant.indexOf(newLink) > -1);
  });

  /**
   * Check if database had already setup
   * @returns {type}
   */
  SettingsStore.prototype.checkDatabaseSetup = function() {
    return systemSettingFetcher.databaseSetup();
  };

  SettingsStore.prototype.destroy = function() {
    var instances = [
      this.contextMenu,
      this.licenseChecker,
      this.dataModel,
      this.advanceSettings,
      this.tenantManagement,
      this.schedulingSearch,
      this.emailConfiguration,
      this.reportConfiguration
    ];

    forEach(invoke('destroy'), instances);
  };

  module.exports = SettingsStore;
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.SettingsStore.js